import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-print-layout-matDialog',
  templateUrl: './print-layout-matDialog.component.html',
  styleUrls: ['./print-layout-matDialog.component.scss']
})
export class PrintLayoutMatDialogComponent {
  @Output() imprimir = new EventEmitter<void>();
  @Output() fechar = new EventEmitter<void>();
  @Input() habilitado = true;
  @Input() retrato: boolean = true;
  @Input() titulo: string = "Imprimir";

  constructor(public authService: AuthService) { }

  onImprimirClick(): void {
    const conteudo = document.querySelector('.page-print')?.outerHTML;
    if (!conteudo) return;

    const janela = window.open('', '', 'width=1000,height=800');
    if (!janela) return;

    let estilos = '';
    Array.from(document.styleSheets).forEach((sheet: any) => {
      try {
        const rules = sheet.cssRules || sheet.rules;
        if (!rules) return;
        Array.from(rules).forEach((rule: any) => {
          if (rule.cssText) estilos += rule.cssText + '\n';
        });
      } catch { }
    });

    const usuarioNome = this.authService.usuario?.nome ?? 'Usuário';
    const dataAtual = new Date().toLocaleString('pt-BR');
    const orientacao = this.retrato ? 'portrait' : 'landscape';

    const html = `
    <html>
      <head>
        <base href="/">
        <title>${this.titulo}</title>
        <link rel="stylesheet" href="/styles.css">
        <style>
          ${estilos}

          @media print {

            @page {
              size: ${orientacao};
              margin: 5mm;
            }

            html, body {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }

            thead {
              display: table-header-group;
            }

            .footer-print-2 {
              display: table-footer-group !important;
            }
          }
        </style>
      </head>

      <body>
        ${conteudo}
      </body>
    </html>
    `;

    janela.document.write(html);
    janela.document.close();

    janela.onload = () => {

      // 🔥 injeta dados dinâmicos no rodapé
      const footer = janela.document.querySelector('.footer-dinamico');
      if (footer) {
        footer.innerHTML = `Emitido por <b>${usuarioNome}</b>, em <b>${dataAtual}</b>`;
      }

      setTimeout(() => {
        janela.print();
        janela.close();
      }, 400);
    };
  }

  onFecharClick(): void {
    this.fechar.emit();
  }
}
